var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28503 9.19602C8.95932 9.19602 10.4636 7.69174 10.4636 5.01745C10.4636 2.34316 8.95932 0.838867 6.28503 0.838867C3.61074 0.838867 2.10645 2.34316 2.10645 5.01745C2.10645 7.69174 3.61074 9.19602 6.28503 9.19602Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9996 9.19602C25.6737 9.19602 27.178 7.69174 27.178 5.01745C27.178 2.34316 25.6737 0.838867 22.9996 0.838867C20.3252 0.838867 18.8209 2.34316 18.8209 5.01745C18.8209 7.69174 20.3252 9.19602 22.9996 9.19602Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28526 27.9997C1.06204 27.9997 1.06201 20.8961 1.06201 14.4193C5.23403 13.1622 7.51754 13.2135 11.5085 14.4193C11.5085 20.8961 11.5085 27.9997 6.28526 27.9997Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9997 13.3745C17.7765 13.3745 17.7765 20.7084 17.7765 27.1852C21.8565 28.2075 24.1434 28.2297 28.223 27.1852C28.223 20.7084 28.223 13.3745 22.9997 13.3745Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.3db0029c37953fc973b7deb3f640f992.svg";
export { ForwardRef as ReactComponent };